export default function ($http) {
    return function (viewModel) {
        return $http({
            url: `/api/scannedLetter/skip/`,
            method: 'PUT',
            data: viewModel
        }).then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/services/letters/skipLetter.js